import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   */
  updateButtonStates() {
  const { minusButton, plusButton } = this.refs;
  const { value } = this.getCurrentValues();
  const effectiveMax = this.getEffectiveMax();

  // Cart buttons are always dynamically managed
  // Minus stays enabled down to 0 so it can act as "remove"
  minusButton.disabled = value <= 0;
  plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
}
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}

// Fix: decrease to 0 removes item from cart
document.addEventListener('click', function(e) {
  const minusBtn = e.target.closest('[name="minus"]');
  if (!minusBtn) return;

  const input = minusBtn.closest('.quantity-selector-wrapper, [class*="quantity"]')?.querySelector('input[type="number"]');
  if (!input) return;

  const currentVal = parseInt(input.value);
  if (currentVal <= 1) {
    // Try data-cart-line (line index) first, then fall back to data-key on the row
    const lineIndex = input.dataset.cartLine;
    const rowKey = input.closest('[data-key]')?.dataset.key;

    if (lineIndex) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(lineIndex), quantity: 0 })
      }).then(() => location.reload());
    } else if (rowKey) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rowKey, quantity: 0 })
      }).then(() => location.reload());
    }
  }
});
